import {createRef, useEffect} from "react";

export const useScrollHandler = () => {
    const scrollableListRef = createRef<HTMLDivElement>();

    useEffect(() => {
        const scrollableDivElement = scrollableListRef.current
        const makeScrollableDeep = () => {
            if (scrollableDivElement) {
                if ((scrollableDivElement?.scrollTop ?? 0) > 0) {
                    scrollableDivElement?.classList.add('scrolling-active');
                } else {
                    scrollableDivElement?.classList.remove('scrolling-active');
                }
            }
        }

        if (scrollableDivElement) {
            scrollableDivElement.addEventListener('scroll', makeScrollableDeep);
        }

        return () => {
            scrollableDivElement?.removeEventListener('scroll', makeScrollableDeep)
        }
    }, [scrollableListRef])

    return scrollableListRef;
}
